export const ContentActionType = {
  GET: "get_content",
  GET_PARENT_CATEGORIES: "get_parent_categories",
};
